/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Row, Form} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import moment from 'moment';

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const GuestsWaitList = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.WAITINGlIST;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  // const [editCategory, setEditCategory] = useState<any>({});
  // const [isEditCatergory, setIsEditCategory] = useState(false);
  // const [iseAddCategory, setIsAddCategory] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  console.log('🚀 ~ Festivals ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');

  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ Festivals ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<CategoryItemType>();
  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);
  // const [editGuest, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  // const [iseAddCategory, setIsAddCategory] = useState(false);

  // console.log(isEditCatergory, iseAddCategory);
  const [Checked, seChecked] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [resetSearchFlag, setResetSearchFlag] = useState(false);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  //   let newSortDirection = 'asc';

  //   if (column === sortColumn) {
  //     newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     newSortDirection = 'desc';
  //   }
  //   ApiUtils.getCategoryList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${column}&sort_direction=${newSortDirection}`,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setSortDirection(newSortDirection);
  //       setSortColumn(column);

  //       setTotalRecords((data as CategoryItemType)?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };
  // useEffect(() => {
  //   console.log('isEditCatergory', isEditCatergory);
  //   if (!isEditCatergory) {
  //     console.log('not updated');
  //     setIsEditCategory(false);
  //   } else {
  //     ApiUtils.getPendingUserList(
  //       `/1?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
  //     )
  //       .then(async (data: any): Promise<void> => {
  //         setCategoryList(data as CategoryItemType);
  //         setTotalRecords(data?.total);
  //       })
  //       .catch((error: any) => {
  //         toast.error(error.message);
  //       });
  //   }
  // }, [isEditCatergory]);

  const toggleCategoryStatus = async (
    id: number,
    status: string,
  ): Promise<void> => {
    // Function to toggle category status

    try {
      console.log(id, status, '-------------');

      // Await status update
      await ApiUtils.updatePendingGuestsUserStatus({id, manual_status: status});

      setIsEditCategory(true);
      // Show toast only if update was successful
      toast.success('Status updated successfully!');
      // console.log('Dekh data update ho gaya ab list load hoga');
      // // Fetch updated list only after successful update
      // const data: any = await ApiUtils.getPendingUserList(
      //   `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
      // );
      // console.log('🚀 ~ After data updated data:', data?.data);

      // setCategoryList(data as CategoryItemType);
      // setTotalRecords(data?.total);
    } catch (error: any) {
      // Handle any error from update or fetch
      const errorMsg =
        Boolean(error.response?.data?.message) ||
        Boolean(error.message) ||
        'Something went wrong';
      toast.error(errorMsg);
      console.error('Error toggling category status:', error);
    }
  };

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };

  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Festivals',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    // {
    //   id: 'parentBox', // Give the column a unique ID
    //   Header: () => (
    //     <input
    //       className="parentCheckbox"
    //       type="checkbox"
    //       checked={allChecked} // This binds the checked state to `allChecked`
    //       value="0"
    //       onChange={() => {
    //         // handleSelectAll();
    //       }}
    //     />
    //   ),
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: '',
    //   Cell: (cell: any) => {
    //     return (
    //       <div className="d-inline-flex align-items-center gap-3">
    //         <input
    //           className={
    //             selectedProductIds.includes(cell.row.original.id)
    //               ? 'checked-class'
    //               : 'unchecked-class'
    //           }
    //           value={cell.row.original.id}
    //           type="checkbox"
    //           checked={selectedProductIds.includes(cell.row.original.id)}
    //           onChange={() => {
    //             handleCheckboxChange(cell.row.original.id);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      Header: 'First Name',
      disableFilters: true,
      filterable: true,
      accessor: 'first_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Last Name',
      disableFilters: true,
      filterable: true,
      accessor: 'last_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Phone Number',
      disableFilters: true,
      filterable: true,
      accessor: 'phone',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Gender',
      disableFilters: true,
      filterable: true,
      accessor: 'gender',
      Cell: (cellProps: any) => {
        return <>{cellProps?.value === 1 ? 'Male' : 'Female'}</>;
      },
    },
    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'manual_status',
      Cell: (cellProps: any) => {
        const toggleStatus = async (newStatusId: number): Promise<void> => {
          const currentStatusId = cellProps?.value;
          console.log(
            '🚀 ~ toggleStatus ~ cellProps:',
            typeof cellProps?.value,
            cellProps?.value,
            newStatusId,
          );

          // Only allow toggling if the status is Pending or when explicitly switching between Approved and Rejected
          if (
            // eslint-disable-next-line eqeqeq
            currentStatusId === 1 || // pending status
            // eslint-disable-next-line eqeqeq
            currentStatusId !== newStatusId
          ) {
            try {
              // Perform the status update
              await toggleCategoryStatus(
                cellProps?.cell?.row?.original?.id,
                String(newStatusId),
              );
            } catch (error) {
              console.error('Error toggling status:', error);
            }
          }
        };

        return (
          <div
            className="form-check form-switch d-flex1 gap-1"
            style={{display: 'block'}}>
            <Form.Group className="d-flex align-items-center">
              {/* Radio button for Approved */}
              <Form.Check
                type="radio"
                id="radioApproved"
                name={`statusRadio${cellProps?.cell?.row?.original?.id}`}
                label="Approve"
                checked={
                  cellProps?.value === 2 // Approved
                }
                onChange={
                  async () => await toggleStatus(2) // Aproved
                }
                // disabled={
                //   cellProps.value === variables.REQUEST_PENDING_STATUS_ID
                // }
                className="form-radio-md me-3" // Added margin to the right
              />

              {/* Radio button for Rejected */}
              <Form.Check
                type="radio"
                name={`statusRadio${cellProps?.cell?.row?.original?.id}`}
                label="Reject"
                checked={Boolean(cellProps?.value) && cellProps?.value === 3}
                onChange={async () => await toggleStatus(3)}
                // disabled={
                //   cellProps.value === variables.REQUEST_PENDING_STATUS_ID
                // }
                className="form-radio-md"
              />
            </Form.Group>
            {/* <div>
              <span
                className={`badge ${
                  cellProps.value === 2 // confirmed
                    ? 'badge-success' // Green badge for Approved
                    : cellProps.value === 3 // reject
                      ? 'badge-danger' // Red badge for Rejected
                      : 'badge-warning' // Yellow badge for Pending
                }`}>
                {cellProps.value === 2 // Approved / confirmed
                  ? variables.REQUEST_APPROVED_STATUS // Display "Approved"
                  : cellProps.value === 3 // Reject
                    ? variables.REQUEST_REJECTED_STATUS // Display "Rejected"
                    : variables.REQUEST_PENDING_STATUS}{' '}
              </span>
            </div> */}
          </div>
        );
      },
    },
    {
      Header: 'Instagram Profile',
      disableFilters: true,
      filterable: true,
      accessor: 'instagram_handle',
      Cell: (cellProps: any) => {
        return (
          <>
            {' '}
            <a
              href={`https://www.instagram.com/${cellProps?.value}`}
              target="_blank"
              rel="noreferrer">
              {cellProps?.value}
            </a>
          </>
        );
      },
    },
    // {
    //   Header: 'How many invite',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'refer_user_count',
    //   Cell: (cellProps: any) => {
    //     return <>{cellProps?.value}</>;
    //   },
    // },
    {
      Header: 'Who invited',
      disableFilters: true,
      filterable: true,
      accessor: 'refer_own_user',
      Cell: (cellProps: any) => {
        return <>{cellProps?.value?.first_name ?? 'Puravida'}</>;
      },
    },
    // {
    //   Header: 'User type',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'user_type',
    //   Cell: (cellProps: any) => {
    //     return (
    //       <>{cellProps?.value === 1 ? 'Guest booking' : 'Puravida user'}</>
    //     );
    //   },
    // },
    {
      Header: 'Utm Source',
      disableFilters: true,
      filterable: true,
      accessor: 'utm_source',
      Cell: (cell: any) => {
        return <>{cell?.value}</>;
      },
    },
    {
      Header: 'Utm Campaign',
      disableFilters: true,
      filterable: true,
      accessor: 'utm_campaign',
      Cell: (cell: any) => {
        return <>{cell?.value}</>;
      },
    },
    {
      Header: 'Created at',
      disableFilters: true,
      filterable: true,
      accessor: 'created_at',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    // {
    //   Header: 'Status',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'manual_status',
    //   Cell: (cellProps: any) => {
    //     return cellProps.value === 2
    //       ? variables.REQUEST_APPROVED_STATUS // Display "Approved"
    //       : cellProps.value === 3
    //         ? variables.REQUEST_REJECTED_STATUS // Display "Rejected"
    //         : variables.REQUEST_PENDING_STATUS;
    //   },

    //   // const toggleStatus = async (newStatusId: number): Promise<void> => {
    //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //   //   const currentStatusId = cellProps?.value;

    //   //   console.log(
    //   //     currentStatusId === variables.REQUEST_REJECTED_STATUS_ID,
    //   //     currentStatusId,
    //   //     variables.REQUEST_REJECTED_STATUS_ID,
    //   //     '--------------abcd',
    //   //   );
    //   //   // Only allow toggling if the status is Pending or when explicitly switching between Approved and Rejected
    //   //   if (currentStatusId === variables.REQUEST_APPROVED_STATUS_ID) {
    //   //     try {
    //   //       // Perform the status update
    //   //       await toggleCategoryStatus(
    //   //         cellProps?.cell?.row?.original?.id,
    //   //         newStatusId,
    //   //       );
    //   //     } catch (error) {
    //   //       console.error('Error toggling status:', error);
    //   //     }
    //   //   }
    //   // };

    //   // return (
    //   //   <div className="form-check form-switch d-flex gap-1">

    //   //       <span
    //   //         className={`badge ${
    //   //           cellProps.value === 2
    //   //             ? 'badge-success' // Green badge for Approved
    //   //             : cellProps.value === 3
    //   //               ? 'badge-danger' // Red badge for Rejected
    //   //               : 'badge-warning' // Yellow badge for Pending
    //   //         }`}>
    //   //         {cellProps.value === 2
    //   //           ? variables.REQUEST_APPROVED_STATUS // Display "Approved"
    //   //           : cellProps.value === 3
    //   //             ? variables.REQUEST_REJECTED_STATUS // Display "Rejected"
    //   //             : variables.REQUEST_PENDING_STATUS}{' '}
    //   //       </span>

    //   //   </div>
    //   // );
    //   // },
    // },

    // {
    //   Header: 'Action',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: (cellProps: any) => {
    //     return (
    //       <Dropdown className="text-start">
    //         <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
    //           <i className="mdi mdi-dots-horizontal" />
    //         </Dropdown.Toggle>
    //         <Dropdown.Menu as="ul" className="dropdown-menu-end">
    //           <li>
    //             <Dropdown.Item
    //               onClick={() => {
    //                 setEditCategory(cellProps);
    //                 modalToggle();
    //               }}>
    //               <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
    //               Update waitlist user Status
    //             </Dropdown.Item>
    //           </li>
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     );
    //   },
    // },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  useEffect(() => {
    console.log('Tu kuyn load ho raha hai bhai???');
    ApiUtils.getGuestsWaitList(
      `?type=user_after_party_waitlist&page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
    )
      .then(async (data: any): Promise<void> => {
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    // setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    // iseAddCategory,
    pageSize,
    search,
    // isStatusChange,
  ]);

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Guests Waitlist Users </h4>
        </div>
        <div id="guests-waitlist">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    // isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search Festivals..."
                    buttonText="Add Festival"
                    onClick={() => {
                      // setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    resetSearchFlag={resetSearchFlag}
                    getRowProps={(row: any): any => {
                      console.log('🚀 ~ row: 1111', row);
                      const status = row.original.manual_status;
                      return {
                        className:
                          status === 3
                            ? 'table-danger'
                            : status === 2
                              ? 'table-success'
                              : '',
                      };
                    }}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editCategory.id !== undefined ? 'Edit Festival' : 'Add Festival'
          }
          modalBody={
            <>
              <SuggestedFestivalForm
                handleClose={modalToggle}
                editCategory={editCategory}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        /> */}

        {/* <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editGuest.id !== undefined ? 'Update Waitlist User Status' : ''
          }
          modalBody={
            <>
              <StatusForm
                handleClose={modalToggle}
                editGuest={editGuest}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        /> */}
      </Container>
    </div>
  );
};

export default GuestsWaitList;
